import Model from '@/models/Model.js';
import moment from '@/plugins/vue-moment.js';

export default class ActivitySettings extends Model {
    static entity = 'activity_settings';

    static modelName = 'ActivitySettings';

    static now = null;

    static fields() {
        return {
            id: this.attr(null),
            activity_settings_template_id: this.attr(null),
            max_attempts_allowed: this.number(null),
            allow_submissions_after_due_date: this.boolean(null),
            due_at: this.attr(null),
            visible_at: this.attr(null),
            points_possible: this.number(null),
            auto_grade: this.boolean(null),
            is_downloadable: this.boolean(null),
            is_extra_credit: this.boolean(null),
            is_for_attendance: this.boolean(null),
            minimum_passing_score: this.attr(null),
            course_authorized_role_id: this.number(null),
            is_remediation: this.attr(null),

            ...super.fields(),

            activity_settings_template: this.belongsTo('activity_settings_templates', 'activity_settings_template_id'),
            activity: this.hasOne('activities', 'activity_id'),
        };
    }

    get is_late() {
        if (!this.due_at) {
            return false;
        }

        ActivitySettings.now = moment.utc();

        const nowInterval = setInterval(() => (ActivitySettings.now = moment.utc()), 1000);

        const isLate = ActivitySettings.now.isAfter(this.due_at);

        if (isLate) {
            clearInterval(nowInterval);
        }

        return isLate;
    }
}
